'use client';

import {cloneElement, isValidElement} from 'react';

import CSS from './Focus.module.scss';

export default function Focus(props: {
  children: React.ReactNode;
  className?: HTMLElement['className'];
  hasLimitedSpace?: boolean;
  /** Apply CSS `animation` in addition to `transition`. */
  hasAnimation?: boolean;
  tabIndex?: HTMLElement['tabIndex'];
}) {
  if (isValidElement(props.children)) {
    const children = props.children;
    const childrenProps = children.props as React.HTMLAttributes<HTMLElement>;
    return cloneElement(children, {
      tabIndex: props.tabIndex || 0,
      className: [
        CSS.focus,
        props.hasLimitedSpace ? CSS.limitedSpace : '',
        props.hasAnimation ? CSS.animation : '',
        props.className || '',
        childrenProps.className || ''
      ].join(' '),
      onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => {
        if (childrenProps.onKeyDown) {
          childrenProps.onKeyDown(event);
        } else if (event.key === 'Enter') {
          event.stopPropagation();
          childrenProps?.onClick?.(event as any);
        }
      }
    } as React.HTMLAttributes<HTMLElement>);
  }

  return null;
}
